import {
  findExxatPaletteSwatch
} from "./chunk-NHLGTEVO.js";

// src/brand-accent-color.ts
var BRAND_ACCENT_LIGHTNESS = 0.5784;
var BRAND_ACCENT_CHROMA = 0.156;
var BRAND_HUE_GRADIENT = "linear-gradient(to right, oklch(0.58 0.16 0), oklch(0.58 0.16 60), oklch(0.58 0.16 120), oklch(0.58 0.16 180), oklch(0.58 0.16 240), oklch(0.58 0.16 300), oklch(0.58 0.16 360))";
function brandAccentOklchFromHue(hue) {
  const h = (hue % 360 + 360) % 360;
  return `oklch(${BRAND_ACCENT_LIGHTNESS} ${BRAND_ACCENT_CHROMA} ${h})`;
}
function parseOklchHue(value) {
  const trimmed = value?.trim();
  if (!trimmed) return null;
  const match = trimmed.match(/oklch\(\s*[\d.]+%?\s+[\d.]+\s+([\d.]+)/i);
  if (!match) return null;
  const hue = Number.parseFloat(match[1]);
  return Number.isFinite(hue) ? hue : null;
}
function normalizeBrandAccentColor(value) {
  const trimmed = value?.trim();
  if (!trimmed) return brandAccentOklchFromHue(280);
  const swatch = findExxatPaletteSwatch(trimmed);
  if (swatch) return swatch.oklch;
  const hue = parseOklchHue(trimmed);
  if (hue !== null) return brandAccentOklchFromHue(hue);
  return trimmed;
}
function isPaletteAnchorColor(value) {
  return findExxatPaletteSwatch(value) !== void 0;
}

export {
  BRAND_ACCENT_LIGHTNESS,
  BRAND_ACCENT_CHROMA,
  BRAND_HUE_GRADIENT,
  brandAccentOklchFromHue,
  parseOklchHue,
  normalizeBrandAccentColor,
  isPaletteAnchorColor
};
